// extracted by mini-css-extract-plugin
module.exports = {"container":"_3OSdF","flag-container":"_2tHwb","flagContainer":"_2tHwb","placeholder":"_1MZ2j"};